import getScenarioFaviconUrl, { type FaviconScenario } from "./getScenarioFaviconUrl";

const SCENARIOS: FaviconScenario[] = ["MailRead", "MailCompose", "Calendar", "Reminder"];
// Retain the images so the browser keeps the decoded icons available for synchronous popout use.
const preloadedFavicons = new Map<string, HTMLImageElement>();

export default function preloadScenarioFavicons(): void {
    if (typeof Image === "undefined") {
        return;
    }
    
    for (const scenario of SCENARIOS) {
        const faviconUrl = getScenarioFaviconUrl(scenario);
        if (!preloadedFavicons.has(faviconUrl)) {
            const favicon = new Image();
            favicon.src = faviconUrl;
            preloadedFavicons.set(faviconUrl, favicon);
        }
    }
}
